module.exports = __webpack_public_path__ + "img/1085309820.6379fb0a.png";